/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor.reducer';

export const TumorDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorEntity = useAppSelector(state => state.tumor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumor.detail.title">Tumor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumor.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.id}</dd>
          <dt>
            <span id="incidentDate">
              <Translate contentKey="tinyMedicRestApp.tumor.incidentDate">Incident Date</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.incidentDate}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.tumor.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.createdBy}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="tinyMedicRestApp.tumor.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.createDate}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumor.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.lastUpdated}</dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="tinyMedicRestApp.tumor.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.lastModifiedBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumor.active">Active</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumor.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumor.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumor.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.timestampEntry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.tumor.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{tumorEntity.notes}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.topography">Topography</Translate>
          </dt>
          <dd>{tumorEntity.topography ? tumorEntity.topography.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.morphology">Morphology</Translate>
          </dt>
          <dd>{tumorEntity.morphology ? tumorEntity.morphology.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.behaviour">Behaviour</Translate>
          </dt>
          <dd>{tumorEntity.behaviour ? tumorEntity.behaviour.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.basisOfDiagnosis">Basis Of Diagnosis</Translate>
          </dt>
          <dd>{tumorEntity.basisOfDiagnosis ? tumorEntity.basisOfDiagnosis.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.icccCode">Iccc Code</Translate>
          </dt>
          <dd>{tumorEntity.icccCode ? tumorEntity.icccCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.condition">Condition</Translate>
          </dt>
          <dd>{tumorEntity.condition ? tumorEntity.condition.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.diagnosis">Diagnosis</Translate>
          </dt>
          <dd>{tumorEntity.diagnosis ? tumorEntity.diagnosis.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.grade">Grade</Translate>
          </dt>
          <dd>{tumorEntity.grade ? tumorEntity.grade.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumor.tumorStatus">Tumor Status</Translate>
          </dt>
          <dd>{tumorEntity.tumorStatus ? tumorEntity.tumorStatus.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor/${tumorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorDetail;
